
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/warehouses/schema",
      function () {
        return require("private-next-pages/events/warehouses/schema.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/warehouses/schema"])
      });
    }
  